export enum DeviceOutputState {
    MOBILE = "mobile",
    MOBILE_APP = "app",
    TABLET = "tablet",
    TABLET_APP = "tabletapp",
    DESKTOP = "desktop",
}
